import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Hero from '../components/Hero/Hero'
import Feature from '../components/Feature/Feature'
import Footer from '../components/Footer/Footer'
import Service from '../components/Service/Service'
import AnimatedContainer from '../components/AnimatedContainer/AnimatedContainer'
import ProfitPulse from '../components/ProfitPulse/ProfitPulse'
import BDesign from '../components/BDesign/BDesign'
import Develop from '../components/Develop/Develop'
import Integrity from '../components/Integrity/Integrity'
import AccountingSystem from '../components/TrackingSystem/TrackingSystem'
import ScrollToTopButton from '../components/ScrollToTopButton/ScrollToTopButton'

const Home = () => {
  return (
    <>
    <Navbar />
    <Hero />
    <Feature/>
    <Service/>
        <AccountingSystem/>
    {/* <BDesign/> */}
    <ProfitPulse/>
    {/* <AnimatedContainer/> */}
    <Develop/>
    <Integrity/>
    <Footer/>
    <ScrollToTopButton />
    </>
  )
}

export default Home
